export const get = () => `LOCAL_${Date.now()}`;
export const isLocal = id => typeof id === 'string' && (id.startsWith('LOCAL') || id === 'new');



// WEBPACK FOOTER //
// ./src/reducers/localId/localId.js